import { Row, Col } from 'antd';
import Home from "./components/Home";

function App() {
  return (
    <Row>
      <Col span={1}></Col>
      <Col span={22}><Home /></Col>
      <Col span={1}></Col>
    </Row>
  );
}

export default App;
